import { FC } from 'react';

import { useSelector } from '@hh.ru/front-static-app';

import { PageHead, PageTitle, PageMeta, PageDescription, PageLink } from 'src/components/PageHead';

const RSS_MIME = 'application/rss+xml';

const Metatags: FC = () => {
    const { ogTitle, description, ogDescription, canonical, rssTitle, rssHref, title, noIndex } = useSelector(
        (state) => state.pageMetaData
    );
    const query = useSelector((state) => state.router.location.query);

    return (
        <PageHead>
            {title && (
                <>
                    <PageTitle>{title}</PageTitle>
                    <PageMeta property="og:title" content={ogTitle || title} />
                </>
            )}
            {description && <PageDescription content={description} openGraphContent={ogDescription} />}
            {(!!Object.keys(query).length || noIndex) && <PageMeta name="robots" content="noindex" />}
            {canonical && <PageLink rel="canonical" href={canonical} />}
            {rssHref && (title || rssTitle) && (
                <PageLink title={rssTitle || title} type={RSS_MIME} rel="alternate" href={rssHref} />
            )}
        </PageHead>
    );
};

export default Metatags;
